import firebase from 'firebase/app'
import FirebaseError from '../errors/firebase-error';
import { initFirebase } from './init';

export const getPromoCode = async (code) => {
    initFirebase();
    const db = firebase.firestore();
    const docRef = db.collection("promo_codes").doc(code);
    let doc = null;
    try {
        doc = await docRef.get();
    } catch (error) {
        window.captureException(error);
        throw new FirebaseError(error);
    }
    if (!doc.exists) {
        // throw new FirebaseError('Document not found');
        return null;
    }
    return doc.data();
}

export const usePromoCode = async (code) => {
    const db = firebase.firestore();
    const docRef = db.collection("promo_codes").doc(code);

    const data = {
        used: Date.now(),
    };
    const ret = await docRef.update(data);
    console.log(ret);
}
